import type { TCreateSlice } from "@/store";

type TStateAdminDashboard = {
    dashboardSelectedCoAIds: number[];
    dashboardSelectedDatabaseIds: number[];
    createCoASelectedDatabases: number[];
};

type TActionsPublic = {
    setDashboardSelectedDatabaseIds: (databaseIds: number[]) => void;
    setDashboardSelectedCoAIds: (coaIds: number[]) => void;
    setCreateCoASelectedDatabases: (databaseIds: number[]) => void;
};

export const initialStateAdminDashboard = {
    dashboardSelectedCoAIds: [],
    dashboardSelectedDatabaseIds: [],
    createCoASelectedDatabases: [],
} as const satisfies TStateAdminDashboard;

export type TSliceAdminDashboard = TStateAdminDashboard & TActionsPublic;

export const createSliceAdminDashboard: TCreateSlice<
    TSliceAdminDashboard,
    Record<string, never>
> = () => set => {
    const actionsPublic: TActionsPublic = {
        setDashboardSelectedDatabaseIds: (databaseIds: number[]) => {
            set(
                { dashboardSelectedDatabaseIds: databaseIds },
                false,
                "AdminDashTStateAdminDashboard/setDashboardSelectedDatabaseIds",
            );
        },
        setDashboardSelectedCoAIds: (coaIds: number[]) => {
            set(
                { dashboardSelectedCoAIds: coaIds },
                false,
                "AdminDashTStateAdminDashboard/setDashboardSelectedCoAIds",
            );
        },
        setCreateCoASelectedDatabases: (databaseIds: number[]) => {
            set(
                { createCoASelectedDatabases: databaseIds },
                false,
                "AdminDashTStateAdminDashboard/setCreateCoASelectedDatabases",
            );
        },
    };

    return {
        ...initialStateAdminDashboard,
        ...actionsPublic,
    };
};
